import { customElement } from 'lit/decorators.js';
import { css, html, LitElement } from 'lit';
import { center, marginTop, padding, paddingTop, row } from '../styles';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { annotation } from './common';

import '../flow/pdq-data-request';
import '../flow/pdq-pagination';
import '../sqlite/pdq-sqlite-import';
import '../sqlite/pdq-sqlite-query';
import '../ui/pdq-pager';
import '@carbon/web-components/es/components/pagination/index.js';

import db from './assets/example.db';


@customElement('pdq-tutorial-sqlite-import-and-pager')
class PDQTutorialSqliteImportDBPaging extends LitElement {
  static styles = [
    paddingTop,
    row,
    center,
    padding,
    annotation,
  ];

  render() {
    const code = `

<pdq-data-request id="example-db-blob-ds" data-type="blob" url="${db}"></pdq-data-request> 
<pdq-sqlite-import database="example.db" blob-name="example-db-blob-ds"></pdq-sqlite-import>
<pdq-sqlite-query datasource="employees-query" database="example.db" sqlite-table="employees">
  <script type="application/sql" slot="query">select * from employees</script>
</pdq-sqlite-query>
<pdq-pagination id="employees-page" source="employees-query" page="3" page-size="5"></pdq-pagination>

<pdq-liquid class="pt-2">
<script type="application/json" slot="variables">[{"name": "page", "source":"employees-page"}]</script>
<script type="application/liquid" slot="liquid">
<div class="row">

<dl style="padding: 32px">
  <dt>Page:</dt><dd>{{page.page}}</dd>
  <dt>Page Size:</dt><dd>{{page.pageSize}}</dd>
  <dt>Item Start:</dt><dd>{{page.start}}</dd>
  <dt>Item End:</dt><dd>{{page.end}}</dd>
  <dt>Total Items:</dt><dd>{{page.totalItems}}</dd>
</dl>
  
<div class="col">
  <cds-table>
    <cds-table-head>
      <cds-table-header-row>
        <cds-table-header-cell>Department</cds-table-header-cell>
        <cds-table-header-cell>Name</cds-table-header-cell>
        <cds-table-header-cell>Email</cds-table-header-cell>
      </cds-table-header-row>
    </cds-table-head>
    <cds-table-body>
      {% for e in page.items %}
      <cds-table-row>
        <cds-table-cell>{{e.department}}</cds-table-cell>
        <cds-table-cell>{{e.first_name}} {{e.last_name}} </cds-table-cell>
        <cds-table-cell>{{e.email}}</cds-table-cell>
      </cds-table-row>
      {% endfor%}
    </cds-table-body>
  </cds-table>
  <pdq-pager page="1" page-sizes="[5,10,25]" source="employees-page"></pdq-pager>
  </div>
</div>
</script>

</pdq-liquid> 

`;

    return html`
      <cds-tile>
        <h2>Sqlite - Import from blob</h2>
        
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
      </cds-tile>
    `;
  }
}